document.addEventListener('alpine:init', () => {
  Alpine.data('ProductFormCustom', () => ({
    product: null,
    selected_options: [],
    selected_type: 'subscribe',
    selected_variant: null,
    selected_selling_plan_id: '',
    selected_selling_plan: null,
    selected_selling_plan_discount: 0,
    selling_plan: null,
    frequencies: ['30 days', '3 months', '6 months'],
    selected_frequency: '',
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      this.$el.addEventListener('change', (e) => {
        // console.log(e);
        this.SetSelections();
      });
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      this.SetSelections();
    },
    SetSelections() {
      let $options = [...this.$el.querySelectorAll('.options input:checked')];
      // console.log($options);
      let selected_options = [...$options.map($option => $option.value)];
      let selected_type = this.selected_type;
      // console.log(this.selected_options, this.selected_type);
      this.selected_options = selected_options;
      this.selected_type = selected_type;

      this.selling_plan_ids = this.product.selling_plan_groups.map(group => group.selling_plans[0].id);
      let selling_plan_discounts = this.product.selling_plan_groups.map(group => group.selling_plans[0].price_adjustments[0].value);
      if (this.selected_selling_plan_id == '') {
        this.selected_selling_plan_id = this.selling_plan_ids[0];
      }
      // console.log(this.frequency_options);

      let selected_variant = this.product.variants.find((variant) => {
        return variant.options.every((option, index) => {
          return option === this.selected_options[index];
        });
      });
      this.selected_variant = selected_variant;
      // console.log(this.selected_variant)

      this.selected_selling_plan = selected_variant.selling_plan_allocations[0];
      this.selected_selling_plan_id = this.selected_selling_plan.selling_plan_id;

      let index = this.selling_plan_ids.indexOf(parseInt(this.selected_selling_plan_id));
      this.selected_frequency = this.frequencies[index];

      this.selected_selling_plan_discount = selling_plan_discounts[index];
    },
    u_GetVariantSellingPlan(variant_id) {
      let variant = this.product.variants.find(v => v.id == variant_id);
      // console.log(variant);
      let selling_plan = variant.selling_plan_allocations[0];
      // console.log({variant,selling_plan});
      return selling_plan;
    },
    u_FormatMoney(value) {
      return formatMoney(value);
    },
    u_GetMaxSavingPercent() {
      if (!this.product) return 0;
      let plans = this.product.selling_plan_groups.map(group => group.selling_plans[0]);
      let max_discount = Math.max(...plans.map(plan => plan.price_adjustments[0].value));
      return max_discount;
    }
  }));

  Alpine.data('MasonryGrid', () => ({
    active_item: 0,
    init() {
      this.$el.removeAttribute('x-cloak-opacity');
    }
  }));

  Alpine.data('Swiper', (options) => ({
    init() {
      this.swiper = new Swiper(this.$el, {
        ...options
      });
    }
  }));

  Alpine.data('FloatingBar', () => ({
    cache: {},
    active: false,
    scroll_position: 0,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.scroll_position = parseFloat(this.$el.dataset.scroll_position) || 80;
    },
    InitWatchers() {
      let $section_bar = this.$el.closest('.shopify-section');
      this.cache.$section_bar = $section_bar;
      let $previous_bar = $section_bar.previousElementSibling;
      this.cache.$previous_bar = $previous_bar;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // When hero section is less than 80% visible (80% scrolled past)
          this.active = entry.intersectionRatio <= (100 - this.scroll_position) / 100;
        });
      }, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      });

      // Start observing the hero section
      observer.observe(this.cache.$previous_bar);
    },

    e_ScrollToTop() {
      this.cache.$previous_bar.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }));

  Alpine.data('LineItemUpgradeSubscription', () => ({
    lineitem: null,
    product: null,
    flags: {
      is_subscription: false,
      packsize: ''
    },
    init() {
      this.InitSelf();
    },
    InitSelf() {
      this.lineitem = JSON.parse(this.$el.dataset.lineitem);
      this.product = JSON.parse(this.$el.dataset.product);
      this.flags.is_subscription = this.lineitem.selling_plan_allocation != null;
      this.flags.packsize = this.lineitem.variant_options[0] || '';
    },
    async e_Upgrade(e) {
      // Handle the upgrade to subscription logic here

      // if not already a subscription, change the line item to subscription
      if (!this.flags.is_subscription) {
        let selling_plan = this.get_UpgradeOptions().selling_plan;
        let res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: this.lineitem.key,
            quantity: this.lineitem.quantity,
            selling_plan: selling_plan.id
          })
        });

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }
      else {
        // already a subscription, upgrade next subsequent pack and selling plan
        let selling_plan = this.get_UpgradeOptions().selling_plan;
        let variant = this.get_UpgradeOptions().variant;

        // remove current line item
        let res_remove = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: this.lineitem.key,
            quantity: 0
          })
        });

        let res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: this.lineitem.quantity,
            selling_plan: selling_plan.id
          })
        });

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));        
      }
    },
    get_UpgradeOptions() {
      let message = 'Upgrade to ';
      let selling_plan, variant;

      if (!this.flags.is_subscription) {
        switch(this.flags.packsize.toLowerCase()) {
          case '1 pack':
            message += ' Subscription & Save 10%';
            selling_plan = this.product.selling_plan_groups.find(group => group.name.toLowerCase().includes('1 month')).selling_plans[0];
            break;
          case '3 pack':
            message += ' Subscription & Save 20%';
            selling_plan = this.product.selling_plan_groups.find(group => group.name.toLowerCase().includes('3 month')).selling_plans[0];
            break;
          case '6 pack':
            message += ' Subscription & Save 30%';
            selling_plan = this.product.selling_plan_groups.find(group => group.name.toLowerCase().includes('6 month')).selling_plans[0];
            break;
          default:
            message += ' Subscription';
        }
      }
      else {
        switch(this.flags.packsize.toLowerCase()) {
          case '1 pack':
            message += ' 3 Pack & Save 20%';
            variant = this.product.variants.find(v => v.options[0].toLowerCase() == '3 pack');
            selling_plan = this.product.selling_plan_groups.find(group => group.name.toLowerCase().includes('3 month')).selling_plans[0];
            break;
          case '3 pack':
            message += ' 6 Pack & Save 30%';
            variant = this.product.variants.find(v => v.options[0].toLowerCase() == '6 pack');
            selling_plan = this.product.selling_plan_groups.find(group => group.name.toLowerCase().includes('6 month')).selling_plans[0];
            break;
          case '6 pack':
            message += ' Complete';
            selling_plan = null;
            break;
        }
      }
      
      return {
        message,
        variant: variant,
        selling_plan
      };
    }
  }));

  Alpine.data('ButtonUpgradeSubscription', () => ({
    showModal: false,
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleModal() {
      this.showModal = !this.showModal;
    },
    async e_UpgradeToSubscription(e) {
  let selling_plan = JSON.parse(e.target.dataset.selling_plan);
  let key = e.target.dataset.key;
  let new_variant_id = e.target.dataset.variant_id;
  let current_variant_id = e.target.dataset.current_variant_id;

  // If variant is changing (pack size upgrade), remove old and add new
  if (new_variant_id && new_variant_id !== current_variant_id) {
    // Remove current line item
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    // Add new variant with new selling plan
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(new_variant_id),
        quantity: 1,
        selling_plan: selling_plan.id
      })
    });
  } else {
    // Just change the selling plan (same variant)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 1,
        selling_plan: selling_plan.id
      })
    });
  }

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}
  }));

  Alpine.data('CartDrawer', () => ({
    cart: null,
    products: [],
    promo_message: '',
    pbars: {
      progress: 0,
      pbar_1: {
        enabled: false,
        threshold: 0,
        progress: 0
      },
      pbar_2: {
        enabled: false,
        threshold: 0,
        progress: 0
      },
      pbar_3: {
        enabled: false,
        threshold: 0,
        progress: 0
      },
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.cart = JSON.parse(this.$el.dataset.cart);
      this.pbars.pbar_1.enabled = this.$el.dataset.pbar_1_enabled == 'true';
      this.pbars.pbar_1.threshold = parseFloat(this.$el.dataset.pbar_1_threshold);
      this.pbars.pbar_2.enabled = this.$el.dataset.pbar_2_enabled == 'true';
      this.pbars.pbar_2.threshold = parseFloat(this.$el.dataset.pbar_2_threshold);
      this.pbars.pbar_3.enabled = this.$el.dataset.pbar_3_enabled == 'true';
      this.pbars.pbar_3.threshold = parseFloat(this.$el.dataset.pbar_3_threshold);
    },
    InitWatchers() {
      document.documentElement.addEventListener('cart:refresh', async (e) => {
        let res = await fetch('/cart.js');
        let cart = await res.json();
        this.cart = cart;
      });

      this.$watch('cart', () => {
        this.UpdateProgressBars();

        this.cart.items.forEach(item => {
          if (this.products.find(p => p.handle == item.handle)) {
            return;
          }
          this.GetProductData(item.handle).then(product => {
            this.products.push(product);
          });
        });
      });
      this.$watch('products', () => {
        this.UpdateProgressBars();
      });
    },
    UpdateProgressBars() {
      let cart_items_minus_sides = this.cart.items.filter(item => {
        let product = this.products.find(p => p.handle == item.handle);
        return product && !product.tags.includes('side-product');
      });
      let cart_total = this.cart.total_price / 100;
      let cart_total_minus_sides = cart_items_minus_sides.reduce((total, item) => {
        return total + (item.line_price / 100);
      }, 0);
      // console.log({cart_total, cart_total_minus_sides});

let threshold = this.pbars.pbar_1.threshold;
  if (this.pbars.pbar_2.enabled && this.pbars.pbar_2.threshold > threshold) {
    threshold = this.pbars.pbar_2.threshold;
  }
  if (this.pbars.pbar_3.enabled && this.pbars.pbar_3.threshold > threshold) {
    threshold = this.pbars.pbar_3.threshold;
}
let progress = Math.min(cart_total / threshold * 100, 100);

      this.pbars.progress = progress;

      // free shipping
      ['pbar_1'].forEach(pbar_key => {
        let pbar = this.pbars[pbar_key];
        if (pbar.enabled) {
          let progress = Math.min(cart_total / pbar.threshold * 100, 100);
          pbar.progress = progress;
        }
      });

let has_33off = this.cart.total_price >= this.pbars.pbar_2.threshold * 100;
this.pbars.pbar_2.progress = has_33off ? 100 : 0;

  let has_free_gift = this.cart.items.some(item => item.discounts.filter(discount => discount.title.includes('FREEGIFT')).length > 0);
  this.pbars.pbar_3.progress = has_free_gift ? 100 : 0;
 // Update promo message

    // Tier 1: Free shipping
    if (this.pbars.pbar_1.enabled) {
      let amount_left = this.pbars.pbar_1.threshold - cart_total;
      if (amount_left > 0) {
        this.promo_message = this.$el.dataset.pbar_1_message.replace('[remaining]', `$${amount_left.toFixed(2)}`);
        return;
      }
    }

    // Tier 2: 33% off
    if (this.pbars.pbar_2.enabled && cart_total >= this.pbars.pbar_1.threshold) {
      let amount_left = this.pbars.pbar_2.threshold - cart_total_minus_sides;
      if (amount_left > 0) {
        this.promo_message = this.$el.dataset.pbar_2_message.replace('[remaining]', `$${amount_left.toFixed(2)}`);
        return;
      } else if (!has_33off) {
        this.promo_message = "Add an item below to get 33% off";
        return;
      }
    }

    // Tier 3: Free gift
    if (this.pbars.pbar_3.enabled && cart_total >= this.pbars.pbar_2.threshold) {
      let amount_left = this.pbars.pbar_3.threshold - cart_total_minus_sides;
      if (amount_left > 0) {
        this.promo_message = this.$el.dataset.pbar_3_message.replace('[remaining]', `$${amount_left.toFixed(2)}`);
        return;
      }
    }

    // All tiers complete
    if (this.pbars.pbar_3.enabled && cart_total >= this.pbars.pbar_3.threshold) {
      this.promo_message = "Complete your routine with the items below.";
    }
    },
    async GetProductData(handle) {
      let res = await fetch(`/products/${handle}.js`);
      let product = await res.json();
      return product;
    }
  }));

  Alpine.data('CartUpsell', () => ({
    async addUpsellProduct(e) {
      (Alpine.debounce(async() => {
        let variantId = e.target.dataset.variant_id;

        let res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));       
      }, 300))();
    }
  }));

  Alpine.data('ScrollVideo', () => ({
    flags: {
      scrubbing: false
    },
    init() {
      this.InitScrollVideo();
    },
    InitScrollVideo() {
      if (this.flags.scrubbing) return;

      new ScrollyVideo({
        // debug: true,
        scrollyVideoContainer: this.$el.id,
        // src: "https://scrollyvideo.js.org/goldengate.mp4"
        src: this.$el.dataset.video_src
      });
      this.flags.scrubbing = true;
    }
  }));
});